'use strict';
const _ = require("lodash");
const Backbone = require("backbone");
const { trackLogin } = require("../util/ga4");
const STORAGE = require('../constants').STORAGE;

module.exports = Backbone.Model.extend({
    defaults: {
        authType: null,
        isAuthorized: false,
        userName: null,
        userID: null,
        firstName: null,
        lastName: null,
        avatar: null,
        email: null,
        optin: false,
        share: {}
    },
    /**
     * Initialize Auth Model
     */
    initialize: function(attrs, options){
        this.google = options.google;
        this.storage = options.storage;
        this.facebook = options.facebook;
    },
    /**
     * Check if a user is already logged in
     */
    initializeType:function() {

        if (!_.isNull(this.storage.fetch(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY))) {
            const foo = this.storage.fetch(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY);
            this.signInSuccess('email', this.storage.fetch(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY));
            trackLogin( 'email' );
        }
    },
    /**
    *
    */
    signInSuccess: function(type, data){
        switch(type) {
            case 'email':
                if(!_.isNull(this.get('userID')) && this.get('userID') !== data) {
                    this.set(this.defaults);
                }
                this.setUpEmailUser(data);
                trackLogin('email');
                break;
            case 'facebook':
                if(!_.isNull(this.get('userID')) && this.get('userID') !== this.facebook.get('id')) {
                    this.set(this.defaults);
                }
                this.setUpFacebookUser();
                trackLogin('facebook');
                break;
            case 'google':
                if(!_.isNull(this.get('userID')) && this.get('userID') !== this.google.get('user').id) {
                    this.set(this.defaults);
                }
                this.setUpGoogleUser();
                trackLogin('google');
                break;
        }
    },
    /**
     * [setUpEmailUser description]
     * @param {[type]} data [description]
     */
    setUpEmailUser: function(data) {

        this.set({
            authType: 'email',
            userName: data,
            userID: data,
            isAuthorized: true
        });
        this.storage.save(STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY, data);
    },
    setUpFacebookUser: function() {
        var fbUser = this.facebook.toJSON();

        if(!_.isNull(fbUser)) {
            this.set({
                authType: 'facebook',
                userID: fbUser.id,
                firstName: fbUser.first_name,
                email: fbUser.email,
                isAuthorized: true
            });
        }
    },

    /**
     * Set up Google User
     */
    setUpGoogleUser: function() {
        var googleUser = this.google.get('user');
        if(!_.isNull(googleUser)) {
            this.set({
                authType: 'google',
                userID: googleUser.id,
                userName: googleUser.name,
                email: googleUser.email,
                isAuthorized: true
            });
        }
    },
    /**
    * [deAuthorize description]
    * @return {[type]} [description]
    */
    deAuthorize: function () {
        if(this.get('authType') === 'email') {
            this.storage.destroy( STORAGE.KEY_PREFIX + STORAGE.EMAIL_KEY );
        }
    }
});



// WEBPACK FOOTER //
// ./app/scripts/models/auth.js